<template>
  <div class="how-it-works-old">
    <h2 class="how-it-works-old__title">
      <template v-if="isUserRestricted"> Coming Soon </template>
      <template v-else-if="isShutdownModeOn"> How Prediction Markets Work </template>
      <template v-else> How It Works </template>
    </h2>
    <div class="how-it-works-old__items row">
      <div v-for="item in items" class="how-it-works-old__item column small-12 large-4">
        <div class="how-it-works-old__item-image-container">
          <img :src="item.icon" class="how-it-works-old__item-image" />
        </div>
        <h4 class="how-it-works-old__item-title">{{ item.title }}</h4>
        <p class="how-it-works-old__item-description">
          {{ item.description }}
        </p>
      </div>
    </div>
  </div>
</template>

<script src="./how-it-works.js"></script>
<style src="./how-it-works.scss" lang="scss"></style>
